import React, { useContext } from 'react';
import { BaseContext } from '../contexts/baseContext';
import { CustomDropdownConversation } from '../utilityComponents/customDropdown';

import img from '../../docs/fondGris.png';
import photo from '../../docs/nature2.png';

export default function ConversationHeader({ nom }) {

  const status = true;
  const { navigateTo } = useContext(BaseContext);

  return (
    <header className="section-conversation-header">
      <div className="user-profil">
        <div className="user-profil--image">
          <i className="bi bi-arrow-left-short icon-back-contact" onClick={() => navigateTo("contacts")} ></i>
          <img src={ img } alt="img" data-src={ photo } />
          {
            status ? <i className="bi bi-dot icon-status"></i> : null
          }
        </div>

        <div className="user-profil--info">
          <span className="user-profil--name">
            { nom }
          </span>
          <span>online</span>
        </div>
      </div>
      <div className="section-conversation-header-menu">
        <CustomDropdownConversation>
          <i className="bi bi-justify"></i>
        </CustomDropdownConversation>
      </div>
    </header>
  );
}
